/*
 * @Author: your name
 * @Date: 2021-12-01 17:15:24
 * @LastEditTime: 2022-02-21 11:05:13
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /fore-trade-birthday-h5/src/components/dfCancelDialog/index.tsx
 */
import React from 'react'
import tipIcon from "@/assets/imgs/notification.png"
import styles from './index.less'

interface PropsTypes {
  icon?:string
  title?: string
  content?: string
  okButton?: string
  cancleButton?: string
  onSure?: () => void
  onCancle?: () => void
}

const ConfirmDialog = (props: PropsTypes) => {
  const {
    icon, title, content, okButton, cancleButton, onSure, onCancle
  } = props

  return (
    <div className={styles['cancelOrderBox']}>
      <div className={styles['myModalContent']}>
        <img src={icon || tipIcon} alt="铃铛" />
        {title && <div className={styles.title}>{title}</div>}
        {content && <div className={styles['tip']}>{content}</div>}
        <div className={styles.btnGroup}>
          {cancleButton && (
            <div className={`${styles.btn} ${styles.cancle}`} onClick={()=>{
              onCancle && onCancle()
            }}>{cancleButton}</div>
          )}
          {okButton && (
            <div className={`${styles.btn} ${styles.active}`} onClick={()=>{
              onSure && onSure()
            }}>{okButton}</div>
          )}
        </div>
      </div>
    </div>
  )
}

export default ConfirmDialog
